import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotPicksSection from './components/HotPicksSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/comics';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: typeof window !== 'undefined' ? window.location.origin : '',
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${typeof window !== 'undefined' ? window.location.origin : ''}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩国漫画网上的漫画是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，韩国漫画网上的所有漫画内容均为免费阅读。我们致力于为广大韩漫爱好者提供免费的漫画阅读服务。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在韩国漫画网上搜索想看的漫画？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过首页的搜索功能输入漫画名称或作者名进行搜索，也可以浏览各个分类页面按类型查找。',
      },
    },
    {
      '@type': 'Question',
      name: '韩国漫画网多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们与韩国各大漫画平台保持同步更新，大部分热门连载漫画每周更新1话。',
      },
    },
    {
      '@type': 'Question',
      name: '什么是下拉式漫画阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '下拉式漫画是为手机和电脑阅读优化的垂直阅读方式，所有内容在一列垂直排列，向下滑动即可连续阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '网站支持手机阅读吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩国漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />

        <nav aria-label="面包屑导航" className="bg-background-50 border-b border-background-200/50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-2.5">
            <ol className="flex items-center gap-1.5 text-xs text-foreground-400">
              <li>
                <a href="/" className="hover:text-primary-500 transition-colors">首页</a>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-[10px]"></i>
              </li>
              <li className="text-foreground-700 font-medium">韩国漫画网 - 韩漫大全在线阅读</li>
            </ol>
          </div>
        </nav>

        <CategorySection />
        <HotPicksSection />
        <LatestUpdatesSection />
        <FAQSection />

        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto text-center">
            <div className="bg-primary-500 rounded-2xl px-6 py-12 md:py-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                立刻开始免费阅读韩漫
              </h2>
              <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-lg mx-auto">
                加入千万韩漫爱好者的大家庭，畅享海量韩国漫画资源
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="/category/action"
                  className="inline-flex items-center gap-2 bg-background-50 hover:bg-background-100 text-primary-600 px-8 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-fire-line"></i>
                  热门漫画
                </a>
                <a
                  href="/category/romance"
                  className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-background-50 px-8 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer border border-background-50/20"
                >
                  <i className="ri-heart-line"></i>
                  恋爱漫画
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}